<ng-container *ngIf="countryCode && src">
  <div 
    class="ws-flag-container"
    [ngClass]="{
      'size-small': size === 'small',
      'size-medium': size === 'medium',
      'size-large': size === 'large',
      'with-border': showBorder
    }"
  >
    <img
      class="ws-flag"
      [src]="src"
      [alt]="altText"
      loading="lazy"
      decoding="async"
      [attr.fetchpriority]="fetchPriority"
      referrerpolicy="no-referrer"
    />
  </div>
</ng-container>

<noscript>
  <!-- No JS? fallback to direct SVG (still cached by SW/HTTP cache) -->
  <div 
    *ngIf="safeUrl"
    class="ws-flag-container"
    [ngClass]="{
      'size-small': size === 'small',
      'size-medium': size === 'medium',
      'size-large': size === 'large',
      'with-border': showBorder
    }"
  >
    <img
      class="ws-flag"
      [src]="safeUrl"
      [alt]="altText"
      loading="lazy"
      decoding="async"
      fetchpriority="low"
      referrerpolicy="no-referrer"
    />
  </div>
</noscript>
